module.exports = __webpack_public_path__ + "img/clip-shadow-people-dancing.69ec387a.jpg";